import { IKeyValueRepository } from '../../../data/repositories/key-value/key-value-repository';
import { IEventService } from '../../../data/services/common/event/event-service';
import { ILogService } from '../../../data/services/common/log/log-service';
import { CustomError } from '../../../helpers/error/custom-error';
import { EventTopic } from '../../../models/common/event-topic/event-topic';
import { RepositoryKey } from '../../../models/common/repository/repository-key';
import { Entity } from '../../../models/entity/entity';

export type SelectEntityRequest = Entity;
export type SelectEntityResponse = Entity;

export class SelectEntityUseCase {
  constructor(
    private logService: ILogService,
    private keyValuerepo: IKeyValueRepository,
    private eventService: IEventService,
  ) {}

  async handle(request: SelectEntityRequest): Promise<SelectEntityResponse> {
    try {
      await this.logService.info('SelectEntityUseCase -> start');
      await this.logService.debug('SelectEntityUseCase -> request', request);
      const savedSelectedEntity = await this.keyValuerepo.get(
        RepositoryKey.SELECTED_ENTITY,
      );

      const newSelectedEntity = {
        ...(savedSelectedEntity || {}),
        ...request,
      };
      delete newSelectedEntity.children;

      if (
        savedSelectedEntity &&
        savedSelectedEntity.id === request.id &&
        JSON.stringify(savedSelectedEntity) === JSON.stringify(newSelectedEntity)
      ) {
        return savedSelectedEntity;
      }

      await this.keyValuerepo.set(
        RepositoryKey.SELECTED_ENTITY,
        newSelectedEntity,
      );

      this.eventService.emit(EventTopic.SELECT_ENTITY, newSelectedEntity);

      return newSelectedEntity;
    } catch (error) {
      throw CustomError.handleError('SelectEntityUseCase', error);
    } finally {
      await this.logService.info('SelectEntityUseCase -> end');
    }
  }
}
